import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles, Box, Container, Typography, useTheme, IconButton, useMediaQuery, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import clsx from 'clsx';
import Qrcode from 'qrcode.react';
import React, { useEffect, useMemo, useState } from 'react';
import { HelvNeue } from 'themes/theme';
import { useBranch } from '@zennya/web-component-library/src/components/BranchIO/BranchProvider'
import { useWindowSize } from 'util/windowUtils';

const ASSETSIZE = 10
const useStyles = makeStyles((theme) => {
  return {
    rootBottom: {
      bottom: 0,
      left: 0,
      right: 0,
      minHeight: 100,
    },
    rootTop: {
      top: 0,
    },
    rootFixed: {
      position: "absolute",
      borderTopLeftRadius: ({mobile})=>mobile?0:theme.shape.borderRadius,
      borderTopRightRadius: ({mobile})=>mobile?0:theme.shape.borderRadius,
      borderBottomLeftRadius: ({mobile})=>mobile?theme.shape.borderRadius:0,
      borderBottomRightRadius: ({mobile})=>mobile?theme.shape.borderRadius:0,
    },
    root:{
      display: 'flex',
      background: "linear-gradient(90.55deg, #74BACD 0.47%, #7F8AAC 94.24%)",
    },
    logo: {
      width: theme.spacing(ASSETSIZE)
    },
    smolLogo: {
      width: theme.spacing(5)
    },
    content: {
      position: 'relative',
      display: "flex",
      flexDirection: "row",
      alignItems: 'center',
      [theme.breakpoints.up("sm")]: {
        paddingLeft: theme.spacing(2),
      },
    },
    title: {
      color: "#fff",
      fontFamily: "HelvNeue",
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    titleMobile: {
      color: "#fff",
      fontFamily: "HelvNeue",
      textAlign: 'start',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      fontWeight: 'bold',
    },
    close: {
      position: "absolute",
      top: 0,
      left: 0,
      color: "#fff",
    },
    button: {
      fontFamily: HelvNeue,
      fontWeight: 'bold',
    }
  }
})
const DesktopPopup = ({ deepLink }) => {

  const winSize = useWindowSize()

  const classes = useStyles({mobile: false})
  const theme = useTheme()
  const [closed, setClosed] = useState(false);

  const [heightBlocked, setHeightBlocked] = useState(false);
  useEffect(() => {
    setHeightBlocked(winSize?.height < 750)
  }, [winSize.height]);

  return (closed || heightBlocked)? <></> : (
    <Container maxWidth="sm" className={clsx(classes.root, classes.rootFixed, classes.rootBottom)}>
      <Box className={classes.content}>
        <img src="/assets/images/zennyasquare.png" className={classes.logo} />
        <Typography variant="h3" className={classes.title}>Scan the QR code to download the app</Typography>
        <Qrcode
          className={classes.logo}
          value={deepLink??""}
          renderAs="png"
          includeMargin
          size={theme.spacing(ASSETSIZE)}
        />
      </Box>
      <IconButton color="secondary" className={classes.close} onClick={() => setClosed(true)} ><Close /></IconButton>
    </Container>
  )
}

const MobilePopup = ({ onClose = () => { } }) => {
  const classes = useStyles({mobile: true})
  const theme = useTheme()
  const [closed, setClosed] = useState(false);
  
  useEffect(() => {
    
  }, []);
  return closed ? <></> : (
    <Container disableGutters className={clsx(classes.root, classes.rootTop)}>
      <Box className={classes.content}>
        <IconButton onClick={() => {
          setClosed(true)
          onClose()
        }}>
          <FontAwesomeIcon icon={faClose} inverse />
        </IconButton>
        <img alt="locationmarker" src="/assets/images/zennyasquare.png" className={classes.smolLogo} />
        <Typography variant="body2" className={clsx(classes.titleMobile)}>Download the app for more healthcare services</Typography>
        <Button variant="contained" className={classes.button}>Install</Button>
      </Box>
    </Container>
  )
}


const AppPopup = ({ onClose = () => { } }) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("xs"), {
    noSsr: true,
  });

  const { deepLink, generateDeeplink } = useBranch({
    apiKey: process.env.REACT_APP_BRANCH_API_KEY,
  });

  useEffect(() => {
    generateDeeplink({ campaign: 'qrcode desktop web', tags: ['desktop', 'customtag2'], data: {  } })
  }, [generateDeeplink]);

  return isMobile ? <></> : <DesktopPopup deepLink={deepLink}/>

}

export { AppPopup }